var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v17.564h512v-17.564 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 144.19,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 55.908
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 55.908
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 55.908
  }), /*#__PURE__*/React.createElement("rect", {
    y: 311.91,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 55.908
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-17.564H0V385.379z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 256,
    cy: 256,
    r: 52.966
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M259.194,223.752l5.217-2.087c0.756-0.302,1.121-1.17,0.787-1.911 c-1.171-2.594-4.305-7.962-10.263-8.124c-3.773-0.102-6.594,0.748-8.186,1.405c-0.813,0.335-1.14,1.303-0.696,2.062l3.148,5.378 L259.194,223.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M254.935,211.63c-0.434-0.012-0.825,0.013-1.234,0.025l-0.568,8.329l3.03,1.678l6.554-5.93 C260.992,213.645,258.462,211.725,254.935,211.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M277.377,272.732l-23.588-27.52c0-5.696,2.058-10.347,3.196-12.486 c3.247-1.45,5.341-5.021,4.469-8.962c-0.633-2.867-2.947-5.206-5.809-5.86c-5.15-1.177-9.719,2.702-9.719,7.65 c0,0.186,0.042,0.361,0.055,0.544c-5.088,1.342-6.034,2.978-6.034,2.978s3.335-0.887,6.229-1.645 c0.058,0.236,0.136,0.463,0.214,0.691l-5.707,1.938l6.232-0.758c0.692,1.266,1.718,2.318,2.957,3.046 c-4.658,3.752-11.81,10.803-11.81,18.763c0,7.278,5.391,12.128,12.181,15.352c2.372,1.128,4.555,2.615,6.349,4.535l0.067,0.072 l0.59,9.035c-4.87,0-10.675,0-13.29,0c-4.915,0-6.265,3.194-6.265,8.477l2.334-3.317l1.966,3.686l0.246-4.178l2.089,2.702 c0,0-0.022-3.53,2.642-3.992c1.412-0.246,6.307-0.553,10.465-0.553l0.881,13.464c-5.639-0.026-12.021,2.629-12.021,2.629 c1.965-0.369,6.758,0.369,6.758,0.369l-0.799,2.335c5.528-3.01,15.665-3.072,15.665-3.072s-2.211-1.508-7.371-2.099l0.119-13.628 h8.111l1.228-3.194c0,0-4.185-5.553-4.185-8.493C272.31,272.473,277.377,272.732,277.377,272.732z M260.691,280.104l0.041-4.674 c2.435,2.61,4.361,4.674,4.361,4.674S263.274,280.104,260.691,280.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696E7D"
    },
    d: "M277.377,276.663c-1.965-7.863-10.58-10.28-19.657-15.726c-9.828-5.897-3.932-15.725-3.932-15.725 s32.926,9.665,35.383,23.588c1.913,10.844-5.897,17.692-9.828,19.657l1.412-3.932h-7.31c0,0,7.74-6.02,7.863-11.795L277.377,276.663 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFCFF"
    },
    d: "M289.172,268.8c-1.643-9.309-16.893-16.707-26.829-20.594l0,0c-3.18-0.354-5.974,4.991,2.749,10.765 c11.735,7.768,12.286,17.692,12.286,17.692l3.932-3.932c-0.122,5.774-7.863,11.795-7.863,11.795h7.31l-1.412,3.932 C283.275,286.492,291.085,279.644,289.172,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M289.172,268.8c-1.089-6.169-8.159-11.492-15.693-15.517c-3.629-1.085-6.79-0.946-6.79-0.946 c2.211,1.352,3.194,4.791,3.194,4.791c-1.597-0.983-5.16-0.491-5.16-0.491c0.991,0.85,1.93,2.582,2.558,3.911 c9.609,7.469,10.097,16.116,10.097,16.116l3.932-3.932c-0.122,5.774-7.863,11.795-7.863,11.795h7.31l-1.412,3.932 C283.275,286.492,291.085,279.644,289.172,268.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 250.59,
    cy: 224.82,
    r: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M247.155,229.813c0,0-2.867,3.358-0.983,4.341s3.701-1.809,3.701-1.809L247.155,229.813z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/ug.91594ced840df0e314cc2c44a68674f6.svg";
export { ForwardRef as ReactComponent };